import { isKshemaOnlyPolicy } from "./companyRules";
import { MOTOR_KEYS, hasRealParts, isDonePart, realParts } from "./policyParts";

/** The policy's own file is really there (an empty object from the database is not a file). */
const hasFile = (doc) => (typeof doc === "string" ? !!doc : !!(doc && (doc.key || doc.location || doc.presignedUrl)));

/** Every motor part that still counts is finished; a policy from before parts existed goes by its job status. */
const motorFinished = (policy) => {
  if (!hasRealParts(policy)) return isDonePart({ status: policy.jobStatus });
  const motor = realParts(policy).filter((p) => MOTOR_KEYS.includes(p.key) && !["cancelled", "skipped"].includes(String(p.status)));
  return motor.length > 0 && motor.every(isDonePart);
};

/**
 * The Make Payment Page link to SHOW for a policy, "" when there is none to show (the owner, 2026-10-30).
 *
 * KSHEMA only: once the policy is finished AND its PDF is stored, the payment page has done its job, so it is not offered
 * any more. Both are needed: a link policy's part finishes when the link is ready, before the customer has paid, and that
 * is exactly when the link must show. It is only hidden: policy.paymentLink stays saved, and comes back by itself if the
 * part is set back to run again.
 *
 * A policy with another insurer keeps its link: it has one link field, which may be the other insurer's and still unpaid.
 */
export const shownPaymentLink = (policy) => {
  const link = (policy && policy.paymentLink) || "";
  if (!link) return "";
  return isKshemaOnlyPolicy(policy) && motorFinished(policy) && hasFile(policy.mergedPolicyPdf) ? "" : link;
};
